<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import PortfolioKpiCard from './PortfolioKpiCard.vue'
import type { KpiStat } from '../types/kpiTypes'

interface Props {
  stats: KpiStat[]
}

defineProps<Props>()
</script>

<template>
  <Box gap="4" class="kpi-row">
    <PortfolioKpiCard
      v-for="stat in stats"
      :key="stat.id"
      v-bind="stat"
    />
  </Box>
</template>

<style scoped>
.kpi-row {
  width: 100%;
}

@media (max-width: 992px) {
  .kpi-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
